import { z } from "zod";
import { DesignElementOrigin } from "../elements";
import { ObjectMeta } from "../../common";

export const ImportModelBase = z.object({
  id: z.string(),
  meta: ObjectMeta,
  origin: DesignElementOrigin,
  brandPersistentId: z.string(),
  sortOrder: z.number(),
});

export type ImportModelBase = z.infer<typeof ImportModelBase>;

export const ImportModelInputBase = ImportModelBase.omit({
  brandPersistentId: true,
  origin: true,
  sortOrder: true,
}).extend({
  originId: z.string(),
  originMetadata: z.record(z.any()),
});

export type ImportModelInputBase = z.infer<typeof ImportModelInputBase>;
